export const SUPPORTED_YEARS = ['2023', '2024', '2025', '2026', '2027', '2028'];

export const WEEK1_2023 = new Date('2023, 09, 07');
export const WEEK1_2024 = new Date('2024, 09, 05');
export const WEEK1_2025 = new Date('2025, 09, 04');
export const WEEK1_2026 = new Date('2026, 09, 09');
export const WEEK1_2027 = new Date('2027, 09, 02');
export const WEEK1_2028 = new Date('2028, 09, 07');

export const SeasonStartingDateString = {
  Year2023: '20230907',
  Year2024: '20240905',
  Year2025: '20250904',
  Year2026: '20260909',
  Year2027: '20270902',
  Year2028: '20280907',
};

export const AvailableSeasons = ['2023', '2024', '2025', '2026'];

export enum SeasonType {
  Regular = 'reg',
  Post = 'post',
  Pre = 'pre',
  All = 'all',
}

export enum MONTHS {
  JAN,
  FEB,
  MAR,
  APR,
  MAY,
  JUN,
  JUL,
  AUG,
  SEP,
  OCT,
  NOV,
  DEC,
}

export enum WeekDays {
  SUN,
  MON,
  TUE,
  WED,
  THU,
  FRI,
  SAT,
}
